import { longWordStreakThrough } from '../ledgerMetrics'
import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'

const VERBOSE_MIN_LENGTH = 5
const VERBOSE_STREAK_COUNT = 10

export const verboseCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isAcceptedWordEntry(entry) || entry.word.length < VERBOSE_MIN_LENGTH) {
    return false
  }
  return longWordStreakThrough(ledger, index, VERBOSE_MIN_LENGTH) === VERBOSE_STREAK_COUNT
}
